import { Views } from '../features/enumerations'
export function ProcessMenu(menu: any[]) {
  menu.forEach((menu: any[]) => {
    process(menu)
  })
  return menu
}

function process(menu: any[]) {
  menu.forEach((item: any) => {
    if (item.children) {
      process(item.children)
    } else if (item.targetView) {
      item.url = (Views as any)[item.targetView]
    }
  })
}
